import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ_ITEMS = [
  {
    q: "O que faz um Perito Judicial Odontológico?",
    a: "O perito judicial odontológico é o cirurgião-dentista que atua como auxiliar da Justiça, analisando documentos, exames, prontuários, radiografias, fotografias clínicas e condições do paciente para elaborar conclusões técnicas imparciais. Seu trabalho inclui análise de tratamentos, avaliação de falhas profissionais, verificação de danos estéticos e funcionais, elaboração de laudos, resposta a quesitos e inspeções clínicas.",
  },
  {
    q: "Qual a diferença entre Perito Judicial e Assistente Técnico?",
    a: "O Perito Judicial é nomeado pelo Juízo e atua como auxiliar imparcial da Justiça. Já o Assistente Técnico é contratado por uma das partes (advogado, empresa ou paciente) para representar seus interesses técnicos — analisando processos, formulando quesitos, acompanhando a perícia oficial e, se necessário, contestando tecnicamente o laudo do perito judicial.",
  },
  {
    q: "Em que tipos de processos a perícia odontológica é solicitada?",
    a: "Em processos cíveis (erro odontológico, indenizações, seguros), criminais (lesões corporais, identificação humana), trabalhistas (acidentes de trabalho com sequelas bucomaxilofaciais), administrativos (planos odontológicos, conselhos de classe) e em demandas envolvendo avaliação de danos por acidentes de trânsito, agressões, quedas e traumas faciais.",
  },
  {
    q: "Como solicitar uma perícia ou parecer técnico?",
    a: "Basta entrar em contato pelo WhatsApp (38) 99905-9959 ou pelo formulário de contato deste site. Após uma análise preliminar do caso, é apresentada uma proposta com prazo, honorários e escopo do trabalho pericial.",
  },
  {
    q: "O perito atua em todo o Brasil?",
    a: "Sim. O atendimento abrange todo o território nacional. Para atos presenciais (exames, vistorias) há deslocamento mediante combinação de honorários. Análises documentais, laudos e pareceres podem ser elaborados remotamente conforme as normas do CPC e do tribunal.",
  },
  {
    q: "O Dr. Sandrey também realiza tratamentos clínicos?",
    a: "Sim. Além da atuação pericial, o consultório oferece tratamentos especializados em Implantodontia, Ortodontia e Endodontia — sempre com o mesmo rigor técnico e atualização científica.",
  },
  {
    q: "Quanto tempo leva para emitir um laudo pericial?",
    a: "O prazo varia conforme a complexidade do caso e o volume da documentação. Em média, laudos simples ficam prontos entre 10 e 20 dias úteis após o recebimento de toda a documentação necessária. Casos complexos podem demandar prazos maiores, sempre informados previamente.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-[#080808]"
    >
      <div className="w-full max-w-5xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-xs tracking-[0.32em] uppercase text-[#D4AF37]">
              Dúvidas Frequentes
            </span>
            <span className="h-px w-10 bg-[#D4AF37]" />
          </div>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight tracking-tight">
            Perguntas{" "}
            <span className="italic text-[#D4AF37]">frequentes</span>.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-px bg-[#D4AF37]/10">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-[#0a0a0a] border-none px-6 sm:px-8"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-serif-display text-base sm:text-lg text-white hover:text-[#D4AF37] hover:no-underline py-6 [&>svg]:text-[#D4AF37] [&>svg]:h-5 [&>svg]:w-5"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="text-white/65 leading-relaxed pb-6 text-sm sm:text-base"
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
